'use strict';

// // AngularJS
//const angular = require('angular');
import "angular";
import "angular-messages";
import "angular-ui-bootstrap";
//import "angular-sanitize";
//import "angular-route";
//import "angular-cookies";
//import "angular-animate";
//import "angular-aria";

//Flow
import {Flow} from "../libs/flowjs";
import "@flowjs/ng-flow/dist/ng-flow-standalone.min.js";

import '../libs/paginate-anything.min.js';

function getJsCookieValue(a) {
	var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
	return b ? b.pop() : '';
}

angular.element(document).ready(function () {
	// Add event listeners for all select2 elements
	angular.element(document).on('select2:open', 'select.select2', function () {
		const ngModelCtrl = angular.element(this).controller('ngModel');
		if (ngModelCtrl) {
			ngModelCtrl.hasOpened = true; // Track that the dropdown was opened
		}
	});

	angular.element(document).on('select2:close', 'select.select2', function () {
		const ngModelCtrl = angular.element(this).controller('ngModel');
		if (ngModelCtrl && ngModelCtrl.hasOpened) {
			ngModelCtrl.$setTouched(); // Mark the field as touched
			if (!ngModelCtrl.$modelValue) {
				// If no selection was made, trigger the required error
				ngModelCtrl.$setViewValue(null); // Ensure it triggers validation
			}
		}
	});

	angular.element(document).on('change', 'select.select2', function () {
		const ngModelCtrl = angular.element(this).controller('ngModel');
		if (ngModelCtrl) {
			ngModelCtrl.hasOpened = false; // Reset the opened state on change
		}
	});
});

var EwSiteApp = angular.module('EwSiteApp', ['ngMessages', 'flow', 'ui.bootstrap']);

EwSiteApp.config(['$provide', function ($provide) {
		$provide.decorator('$browser', ['$delegate', function ($delegate) {
				$delegate.onUrlChange = function () {};
				$delegate.url = function () {
					return "";
				};
				return $delegate;
			}]);
	}]);

EwSiteApp.filter('u2date', ['$filter', function ($filter) {
		return function (udate) {
			var format = 'yyyy-MM-dd';
			if (arguments[1]) {
				format = arguments[1];
			}
			return $filter('date')(udate * 1000, format);
		};
	}]);

EwSiteApp.service("ajaxSearch", ['$http', '$q', function ($http, $q) {
		return({
			search: search
		});

		function search(url) {
			var cfg = {
				method: 'GET',
				url: url
			};
			if (arguments[1]) {
				cfg.params = arguments[1];
			}
			var request = $http(cfg);
			return(request.then(succesHandler, errorHandler));
		}
		;

		function succesHandler(response) {
			return response.data;
		}

		function errorHandler(response) {
			if (!angular.isObject(response.data) || !response.data.message) {
				return($q.reject("An unknown error occurred."));
			}
			return($q.reject(response.data.message));
		}
		;
	}]);

EwSiteApp.config(['flowFactoryProvider', function (flowFactoryProvider) {
    // Utility function to get a cookie value
    function getJsCookieValue(a) {
		let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
		return b ? b.pop() : '';
	}

	flowFactoryProvider.defaults = {
		target: '',
		permanentErrors: [202, 404, 500, 501],
		maxChunkRetries: 1,
		chunkRetryInterval: 5000,
		simultaneousUploads: 1,
        singleFile: false,
		chunkSize: 2 * 1024 * 1024,
		forceChunkSize: true,
		testChunks: false
	};

    // Workaround for issue https://github.com/flowjs/ng-flow/issues/92
	flowFactoryProvider.factory = function (opts) {
		let Flow = require('@flowjs/flow.js/dist/flow.js');
		return new Flow(opts);
	};

	// Add XSRF header to upload requests
    if (typeof (secure_xsrf_name) != 'undefined') {
        var xsrf_token = getJsCookieValue(secure_xsrf_name);
        if (xsrf_token !== '') {
			flowFactoryProvider.defaults.headers = {};
            flowFactoryProvider.defaults.headers['X-' + secure_xsrf_name] = xsrf_token;
		}
	}

	flowFactoryProvider.on('fileSuccess', function (file, response) {
		file.response = angular.fromJson(response);
	});
}]);

export {EwSiteApp};
